export default __webpack_public_path__ + "static/media/Electro_Optical.441a4897.png";